export default __webpack_public_path__ + "static/media/iphones.b55105ef.png";